
import Vue from 'vue'
import DynamicMarquee from 'vue-dynamic-marquee'

export default Vue.extend({
    name: 'Marquees',
    components: {
		DynamicMarquee
	},
	props: {
		disabled: Boolean
	},
	data(){
		return{
			marquees: [
				"gmail.png",
				"google-docs.png",
				"google-drive.png",
				"slack.png",
				"linkedin.png",
				"linear.png",
				"twitter.png",
				"google-sheets.png",
				"salesforce.png",
				"twilio.png",
				"airtable.png",
				"hubspot.png",
				"more.png"
			]
		}
	}
})
